import { render, staticRenderFns } from "./ex-prolist.vue?vue&type=template&id=073deeb2&scoped=true&"
import script from "./ex-prolist.vue?vue&type=script&lang=js&"
export * from "./ex-prolist.vue?vue&type=script&lang=js&"
import style0 from "./ex-prolist.vue?vue&type=style&index=0&id=073deeb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073deeb2",
  null
  
)

export default component.exports